<div class='station-card-dialog'>
    <h2 mat-dialog-title>{{ data.name }}</h2>
    
    <div mat-dialog-content>
        <h5>Select the source</h5>
        
        <div>
            <mat-form-field appearance="standard">
                <mat-select data-testid="source-option" [(ngModel)]="sourceSelected" placeholder="Select Source">
                  <mat-option *ngFor="let stationSource of stationSourceList" [value]="stationSource">
                      {{ stationSource.name }}
                  </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div mat-dialog-actions class="float-right">
            <button data-testid="cancel-dialog" mat-raised-button mat-dialog-close (click)="cancel()">Cancel</button>
            <button data-testid="ok-dialog" mat-raised-button color="primary" (click)="confirm()">Ok</button>
        </div> 

    </div>
</div>
